module.exports = __webpack_public_path__ + "static/media/large-car.7f257035.svg";